import { render, staticRenderFns } from "./RtoObjectiveArea.vue?vue&type=template&id=1a077263&scoped=true&"
import script from "./RtoObjectiveArea.vue?vue&type=script&lang=js&"
export * from "./RtoObjectiveArea.vue?vue&type=script&lang=js&"
import style0 from "./RtoObjectiveArea.vue?vue&type=style&index=0&id=1a077263&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a077263",
  null
  
)

export default component.exports